import { Modal, Space, Avatar, Flex, Input, Select, message, Tooltip, Button } from "antd";
import { useEffect, useState } from "react";
import { fetchSystemTaskList, sendSystemTaskReward } from "../../api/points";
import { UserOutlined } from "@ant-design/icons";

const SendPointsModalView = ({ user, open, onClose }) => {
    const [tasks, setTasks] = useState([]);
    const [point, setPoint] = useState(null);
    const [description, setDescription] = useState(null);
    const [taskId, setTaskId] = useState(null);
    const [loading, setLoading] = useState(false);
    const [userAvatar, setUserAvatar] = useState(null);

    useEffect(() => {
        if (!open) {
            setPoint(null);
            setDescription(null);
        }
    }, [open]);

    useEffect(() => {
        if (user) {
            setUserAvatar(user.picture ? user.picture : user.avatar);
        } else {
            setUserAvatar(null);
        }
    }, [user]);

    useEffect(() => {
        fetchSystemTaskList({ 'page.disable': true }).then(res => {
            if (res.list) {
                setTasks(res.list.map(item => {
                    return {
                        label: item.title,
                        value: item.id,
                    }
                }));
                setTaskId(res.list.filter(item => item.eventType === 'SystemReward')[0]?.id);
            }
        })
    }, [])

    const onSubmit = () => {
        let params = {
            taskId, point, description,
            userId: user?.userId,
        };
        setLoading(true);
        sendSystemTaskReward(params).then(res => {
            if (res) {
                onClose();
                message.success('Points sent!');
            } else {
                message.error('Failed to send points');
            }
        }).catch(err => {
            message.error(String(err));
        }).finally(() => {
            setLoading(false);
        });
    }

    const getVerification = (type, description) => {
        if (type === 'VerifiedUser' || type === 'VerifiedOrganisation') {
            if (description) {
                return (
                    <Tooltip title={description}>
                        <div>
                            <Avatar size={16} src={type === 'VerifiedUser' ? '/images/personal.png' : '/images/company.png'} />
                        </div>
                    </Tooltip>
                )
            }
            return <Avatar size={16} src={type === 'VerifiedUser' ? '/images/personal.png' : '/images/company.png'} />
        }
        return <div />
    }

    let verify = (user?.certifications ?? [])[0]?.type;

    return (
        <Modal open={open} onCancel={onClose} title='Send Points' footer={
            <Space>
                <Button onClick={onClose}>Cancel</Button>
                <Button onClick={onSubmit} type="primary" loading={loading}>
                    Submit
                </Button>
            </Space>
        }>
            <div>
                <div style={{ marginTop: 32 }} />
                {
                    user && (
                        <Space size={4} style={{ justifyContent: 'center', width: '100%' }}>
                            {
                                userAvatar ?
                                    <Avatar size={48} src={userAvatar} />
                                    :
                                    <Avatar size={48} icon={<UserOutlined />} style={{ backgroundColor: '#87d068' }} />
                            }
                            <div>
                                <Flex align='center'>
                                    <b style={{ marginRight: 4 }}>{user.name ? user.name : user.email}</b>
                                    {getVerification(verify, description)}
                                </Flex>
                                <div style={{ color: '#afafaf', fontSize: 12 }}>{user.name ? user.email : ''}</div>
                            </div>
                        </Space>
                    )
                }
                <div style={{ marginTop: 32 }} />
                <Flex align='center'>
                    <div style={{ width: 120, textAlign: 'right', marginRight: 10 }}>Task:</div>
                    <Select
                        style={{ width: 300 }}
                        options={tasks}
                        value={taskId}
                        disabled
                    />
                </Flex>
                <div style={{ marginTop: 12 }} />
                <Flex align='center'>
                    <div style={{ width: 120, textAlign: 'right', marginRight: 10 }}>Points:</div>
                    <Input style={{ width: 300 }} value={point} placeholder="Reward points" type="number" onChange={evt => {
                        setPoint(evt.target.value);
                    }} allowClear />
                </Flex>
                <div style={{ marginTop: 12 }} />
                <Flex align='center'>
                    <div style={{ width: 120, textAlign: 'right', marginRight: 10 }}>Description:</div>
                    <Input style={{ width: 300 }} value={description} placeholder="Reward description" onChange={evt => {
                        setDescription(evt.target.value);
                    }} allowClear />
                </Flex>
                <div style={{ marginTop: 20 }} />
            </div>
        </Modal>
    )
}

export default SendPointsModalView;